export class RentalStockModalModel {
  id: number = 0;
  articleId: number = 0;
  articleCode: number = 0;
  articleAlterCode: string | null = null;
  articleName: string = "";
  typeArticleId: number = 0;
  typeArticle: string = "";
  articleActive: boolean = false;
  storeId: number = 0;
  storeCode: number = 0;
  storeName: string = "";
  stock: number = 0;
  predevolutionQuantity: number = 0;
  update: boolean = false;
}